import React from 'react'
import Constants from 'EurestoFonction/Constants'

import Formulaire from 'Components/Formulaire'
import Template from './form'

const columns = [{
  header: 'Id',
  id: 'id',
  show: false,
}, {
  id: 'libelle',
  headerClassName: 'EurestoPrimary EurestoText--text',
  header: <strong style={{
    display: 'block',
    width: '100%'
  }}>{EurestoI18n.t('commun:Onglet')}</strong>,
  type: 'string',
  filter: ['string']
}, {
  header: EurestoI18n.t('commun:Ordre'),
  id: 'ordre',
  type: 'number',
}]

export default React.memo(props => <Formulaire defaultObject={{
  libelle: undefined, actif: 1, ordre: 1, qualites: []
}} title={EurestoI18n.t('commun:Onglet')} columnSearch={'id'} form={<Template/>} module={Constants.module.CRM} requete={Constants.donnee.onglet} columns={columns}/>)


// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/CRM/Onglet/index.js